const useBrevoWidget = () => {
    const config = useRuntimeConfig()

    onMounted(() => {
        const script = document.createElement('script')
        script.async = true
        script.src = config.public.brevo.chat.src
        window.BrevoConversationsID = config.public.brevo.chat.converstaionId

        script.onload = () => {
            window.BrevoConversations =
                window.BrevoConversations ||
                function () {
                    ;(window.BrevoConversations.q = window.BrevoConversations.q || []).push(arguments)
                }
        }

        if (document.head) {
            document.head.appendChild(script)
        }
    })

    onBeforeUnmount(() => {
        window?.BrevoConversations('kill', true)
    })

    const openChat = () => {
        window?.BrevoConversations('openChat', true)
    }

    return {
        openChat
    }
}

export default useBrevoWidget
